import React, {useState, useRef} from 'react';
import { useSelector } from 'react-redux';
import ExpenseMprReport from '../../../components/Multi/MRP/ExpenseMprReport';
import SubHeader from '../../../components/Subheader/Subheader';

const ExpenseMprReportPage = () => {
  const { financialYears } = useSelector((state) => state.authData);
  const fyIdRef = useRef(localStorage.getItem('globalDateId'));
  const fyList = financialYears.payload.fy_list;
  const handlePageTrigger = () => {
      fyIdRef.current = localStorage.getItem('globalDateId');
  }

  return (
    <div>
      <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
      <ExpenseMprReport fy_list={fyList}/>
    </div>
  )
}

export default ExpenseMprReportPage
